var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ed7850;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272,384c9.6-31.9,29.5-59.1,49.2-86.2h0c5.2-7.1,10.4-14.2,15.4-21.4,19.8-28.5,31.4-63,31.4-100.3C368,78.8,289.2,0,192,0S16,78.8,16,176s11.6,71.9,31.4,100.3c5,7.2,10.2,14.3,15.4,21.4h0c19.8,27.1,39.7,54.4,49.2,86.2h160ZM192,512c44.2,0,80-35.8,80-80v-16H112v16c0,44.2,35.8,80,80,80ZM112,176c0,8.8-7.2,16-16,16s-16-7.2-16-16c0-61.9,50.1-112,112-112s16,7.2,16,16-7.2,16-16,16c-44.2,0-80,35.8-80,80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbSolid);
export default __webpack_public_path__ + "static/media/lightbulb-solid.0db503dd4a23e7122d68d2f2b2b8c5c1.svg";
export { ForwardRef as ReactComponent };